import { gql } from "@apollo/client";

export const CONFIRM_COMPLETION_UPLOAD_FILES = gql`
  mutation confirmCompletionUploadedFiles($quoteId: Int!) {
    confirmCompletionUploadedFiles(quoteId: $quoteId)
  }
`;

export const CONFIRM_CONTRACTUAL_UPLOADED_FILES = gql`
  mutation confirmContractualUploadedFiles($quoteId: Int!) {
    confirmContractualUploadedFiles(quoteId: $quoteId)
  }
`;
